import { Avatar, Title } from "@mantine/core";

const PurchaseOrderCard = ({ props, onClick }) => {
  const {
    name = "",
    partner = "",
    purchaseDate = "",
    deliveryDate = "",
    orderStatus = "",
  } = props;

  return (
    <div
      className="mx-4 my-4 flex max-w-md cursor-pointer flex-col rounded-lg bg-white p-6 shadow-lg md:mx-8 md:max-w-2xl"
      onClick={onClick}
    >
      <Title className="py-2" order={1}>
        {name || null}
      </Title>
      <div className="py-2">{orderStatus}</div>
    </div>
  );
};

export default PurchaseOrderCard;
